// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"SubmitButton_buttonsContainer__bn6FV","mainButton":"SubmitButton_mainButton__sgL6b"};